import { render, staticRenderFns } from "./LettersAndMailingsPage.vue?vue&type=template&id=9b90116a&scoped=true&"
import script from "./LettersAndMailingsPage.vue?vue&type=script&lang=js&"
export * from "./LettersAndMailingsPage.vue?vue&type=script&lang=js&"
import style0 from "./LettersAndMailingsPage.vue?vue&type=style&index=0&id=9b90116a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b90116a",
  null
  
)

export default component.exports